export interface PermissionSet {
  type: number;
  name: string;
  description: string;
  permissions: PermissionDefinition[];
}

export interface PermissionDefinition {
  type: number;
  name: string;
  description: string;
}

export enum PermissionSetTypes {
  System = 1,
  GrantProgram = 2,
  GrantApplication = 3,
  DataHub = 4
}

export enum CardPageTypes {
  PROGRAM = 1,
  SETTINGS = 2,
  INSIGHTS = 3,
  ADMIN_SETTINGS = 4,
  CLIENT_MANAGEMENT = 5,
  PRODUCT_MANAGEMENT = 6,
  REPORTING = 7,
  APP_MANAGER = 8,
  PAYMENT_PROCESSING = 9
}

